import React from "react";
import { NotesEditor } from "@/components/notes/NotesEditor";

interface PanelProps {
  isMobile?: boolean;
}

export const NotesPanel: React.FC<PanelProps> = () => {
  return (
    <div className="h-full w-full">
      <NotesEditor />
    </div>
  );
};
